// extracted by mini-css-extract-plugin
export var button = "transition-score-module--button--RHRBj";
export var container = "transition-score-module--container--2jW9e";
export var iconBox = "transition-score-module--icon-box--xbY9N";
export var img = "transition-score-module--img--5r3gE";
export var preview = "transition-score-module--preview--RwelH";